import styled, { css } from 'styled-components';

export const Card = styled.section(
  ({ theme }) => css`
    width: 100%;
    max-width: none;
    padding: ${theme.sz.s3} ${theme.sz.s2} ${theme.sz.s1};
    border: ${theme.bo.thinWidth} solid ${theme.co.primary80};
    border-radius: ${theme.bo.medium};
    background-color: ${theme.co.neutral99};
    box-shadow: 0 ${theme.sz.s05} ${theme.sz.s2} hsla(45, 60%, 40%, 0.08);
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${theme.sz.s2} ${theme.sz.s1};
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xxxs};
    margin: 0;
    color: ${theme.co.neutral40};
    letter-spacing: 0.04em;
    text-transform: uppercase;
  `,
);

export const Count = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xxxs};
    color: ${theme.co.neutral40};
  `,
);

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Row = styled.li(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
    padding: ${theme.sz.s2};

    & + & {
      border-top: ${theme.bo.thinWidth} solid ${theme.co.secondary95};
    }
  `,
);

export const Flower = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};

    > div,
    svg {
      width: 100%;
      height: 100%;
    }
  `,
);

export const Words = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

export const Target = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    color: ${theme.co.neutral10};
    overflow-wrap: anywhere;
  `,
);

export const Source = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.neutral40};
    overflow-wrap: anywhere;
  `,
);
